module.exports = __webpack_public_path__ + "img/list4.7fb06cc6.png";